/**
 * icons/home.js
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

// Standard Material UI icons
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import SearchIcon from '@mui/icons-material/Search';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import TuneIcon from '@mui/icons-material/Tune';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import AddAPhotoOutlinedIcon from '@mui/icons-material/AddAPhotoOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import AddBoxIcon from '@mui/icons-material/AddBox';
import WarningOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import DoneIcon from '@mui/icons-material/Done';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import LightningIcon from '@mui/icons-material/FlashOn';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import LockOutlined from '@mui/icons-material/LockOutlined';
import DialpadIcon from '@mui/icons-material/Dialpad';
import RefreshIcon from '@mui/icons-material/Refresh';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SyncIcon from '@mui/icons-material/Sync';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import LayersIcon from '@mui/icons-material/LayersOutlined';
import NearMeIcon from '@mui/icons-material/NearMeOutlined';
import LocationOffOutlinedIcon from '@mui/icons-material/LocationOffOutlined';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import StopOutlinedIcon from '@mui/icons-material/StopOutlined';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import PolylineOutlinedIcon from '@mui/icons-material/PolylineOutlined';
import SaveIcon from '@mui/icons-material/SaveOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import FilterListIcon from '@mui/icons-material/FilterList';
import AccountBoxIcon from '@mui/icons-material/AccountBox';


// Custom SVG icons
import { ReactComponent as TrainingIconSVG } from 'assets/images/icons/training.svg';
import { ReactComponent as ExerciseIconSVG } from 'assets/images/icons/exercise.svg';
import { ReactComponent as DogsIconSVG } from 'assets/images/icons/dogs.svg';
import { ReactComponent as DeployIconSVG } from 'assets/images/icons/deployment.svg';
import { ReactComponent as RecordsIconSVG } from 'assets/images/icons/records.svg';
import { ReactComponent as DogTypesIconSVG } from 'assets/images/icons/dog-types.svg';
import { ReactComponent as RunFastIconSVG } from 'assets/images/icons/run-fast.svg';
import { ReactComponent as LadderIconSVG } from 'assets/images/icons/ladder.svg';
import { ReactComponent as TransferIconSVG } from 'assets/images/icons/transfer.svg';
import { ReactComponent as ScriptTextOutlineIconSVG } from 'assets/images/icons/script-text-outline.svg';
import { ReactComponent as FileEyeOutlineIconSVG } from 'assets/images/icons/file-eye-outline.svg';
import { ReactComponent as HomeCityOutlineIconSVG } from 'assets/images/icons/home-city-outline.svg';
import { ReactComponent as WhistleOutlineModIconSVG } from 'assets/images/icons/whistle-outline-mod.svg';
import { ReactComponent as ImageSearchOutlineIconSVG } from 'assets/images/icons/image-search-outline.svg';
import { ReactComponent as BottleTonicSprayIconSVG } from 'assets/images/icons/bottle-tonic-spray.svg';
import { ReactComponent as ShapeOutlineIconSVG } from 'assets/images/icons/shape-outline.svg';
import { ReactComponent as BriefcaseSearchOdorOutlineIconSVG } from 'assets/images/icons/briefcase-search-odor-outline.svg';
import { ReactComponent as MapMarkerPathIconSVG } from 'assets/images/icons/map-marker-path.svg';
import { ReactComponent as AccountMultiplePlusOutlineIconSVG } from 'assets/images/icons/account-multiple-plus-outline.svg';
import { ReactComponent as PlaylistEditIconSVG } from 'assets/images/icons/playlist-edit.svg';
import { ReactComponent as NewspaperVariantOutlineIconSVG } from 'assets/images/icons/newspaper-variant-outline.svg';
import { ReactComponent as AccountSearchOutlineIconSVG } from 'assets/images/icons/account-search-outline.svg';
import { ReactComponent as CommentQuoteOutlineIconSVG } from 'assets/images/icons/comment-quote-outline.svg';
import { ReactComponent as AccountQuestionmarkOutlineIconSVG } from 'assets/images/icons/account-questionmark-outline.svg';
import { ReactComponent as ChevronDownCircleOutlineIconSVG } from 'assets/images/icons/chevron-down-circle-outline.svg';
import { ReactComponent as AccountGroupOutlineIconSVG } from 'assets/images/icons/account-group-outline.svg';
import { ReactComponent as FlagVariantOutlineIconSVG } from 'assets/images/icons/flag-variant-outline.svg';
import { ReactComponent as BusIconSVG } from 'assets/images/icons/bus.svg';
import { ReactComponent as EventQuestionIcon } from 'assets/images/icons/calendar-question.svg';
import { ReactComponent as CheckboxBlankCircleSVG } from 'assets/images/icons/checkbox-blank-circle.svg';
import { ReactComponent as CheckboxBlankCircleOutlineSVG } from 'assets/images/icons/checkbox-blank-circle-outline.svg';
import { ReactComponent as ClipboardCheckIconSVG } from 'assets/images/icons/clipboard-check.svg';
import { ReactComponent as ClipboardMultipleOutlineSVG } from 'assets/images/icons/clipboard-multiple-outline.svg';
import { ReactComponent as FilledCircleMultipleSVG } from 'assets/images/calendar/filled-circle-multiple.svg';
import { ReactComponent as OutlinedCircleMultipleSVG } from 'assets/images/calendar/outlined-circle-multiple.svg';
import { ReactComponent as FilledStarMultipleSVG } from 'assets/images/calendar/filled-star-multiple.svg';
import { ReactComponent as OutlinedStarMultipleSVG } from 'assets/images/calendar/outlined-star-multiple.svg';
import { ReactComponent as FilledSquareMultipleSVG } from 'assets/images/calendar/filled-square-multiple.svg';
import { ReactComponent as OutlinedSquareMultipleSVG } from 'assets/images/calendar/outlined-square-multiple.svg';
import { ReactComponent as PlusSVG } from 'assets/images/calendar/plus.svg';
import { ReactComponent as PlusMultipleSVG } from 'assets/images/calendar/plus-multiple.svg';
import { ReactComponent as ShieldAccountSVG } from 'assets/images/icons/shield-account.svg';
import { ReactComponent as ShieldAccountOutlineSVG } from 'assets/images/icons/shield-account-outline.svg';
import { ReactComponent as ShieldAlertSVG } from 'assets/images/icons/shield-alert-outline.svg';
import { ReactComponent as ShieldCheckIcon } from 'assets/images/icons/shield-check.svg';
import { ReactComponent as SquareIconSVG } from 'assets/images/calendar/square.svg';
import { ReactComponent as SquareOutlinedIconSVG } from 'assets/images/calendar/square-outline.svg';
import { ReactComponent as CircleHalfFull } from 'assets/images/icons/circle-half-full.svg';
import { ReactComponent as ClipboardClockOutline } from 'assets/images/icons/clipboard-clock-outline.svg';
import { ReactComponent as PoliceStationSVG } from 'assets/images/icons/police-station.svg';
import { ReactComponent as CommentMultipleOutline } from 'assets/images/icons/comment-multiple-outline.svg';
import { ReactComponent as ReloadAlert } from 'assets/images/icons/reload-alert.svg';
import { ReactComponent as TextBoxOutline } from 'assets/images/icons/text-box-outline.svg';
import { ReactComponent as TextBoxCheckOutline } from 'assets/images/icons/text-box-check-outline.svg';
import { ReactComponent as TextBoxSearchOutline } from 'assets/images/icons/text-box-search-outline.svg';
import { ReactComponent as CardAccountDetails } from 'assets/images/icons/card-account-details-outline.svg';
import { ReactComponent as CardRemove } from 'assets/images/icons/credit-card-remove-outline.svg';
import { ReactComponent as CardEdit } from 'assets/images/icons/credit-card-edit-outline.svg';
import { ReactComponent as CalendarRefresh } from 'assets/images/icons/calendar-refresh-outline.svg';
import { ReactComponent as CloseBoxIconSVG } from 'assets/images/icons/close-box.svg';
import { ReactComponent as ArrowUpBoldIcon } from 'assets/images/icons/arrow-up-bold.svg';
import { ReactComponent as ArrowDownBoldIcon } from 'assets/images/icons/arrow-down-bold.svg';
import { ReactComponent as HumanQueue } from 'assets/images/icons/human-queue.svg';
import { ReactComponent as Ungroup } from 'assets/images/icons/ungroup.svg';
import { ReactComponent as AccountTieHatOutlne } from 'assets/images/icons/account-tie-hat-outline.svg';
import { ReactComponent as GroupMembers } from 'assets/images/icons/group-members.svg';
import { ReactComponent as ExitRun } from 'assets/images/icons/exit-run.svg';
import { ReactComponent as AccountCheckOutline } from 'assets/images/icons/account-check-outline.svg';
import { ReactComponent as EmailFastOutline } from 'assets/images/icons/email-fast-outline.svg';
import { ReactComponent as NotificationsEditIcon } from 'assets/images/icons/bell-cog-outline.svg';
import { ReactComponent as LocationAddOutline } from 'assets/images/icons/location-add-outline.svg';
import { ReactComponent as FilterPlusIconSVG } from 'assets/images/icons/filter-plus.svg';
import { ReactComponent as FilterRemoveIconSVG } from 'assets/images/icons/filter-remove.svg';
import { ReactComponent as ShortcutIconSVG } from 'assets/images/icons/shortcut.svg';
import { ReactComponent as LightbulbOnOutlineSVG } from 'assets/images/icons/lightbulb-on-outline.svg';
import { ReactComponent as MapMarkerRadiusOutline } from 'assets/images/icons/map-marker-radius-outline.svg';
import { ReactComponent as MapMarkerStarOutline } from 'assets/images/icons/map-marker-star-outline.svg';
import { ReactComponent as DogService } from 'assets/images/icons/dog-service.svg';
import { ReactComponent as CameraMarkerOutline } from 'assets/images/icons/camera-marker-outline.svg';
import { ReactComponent as WifiMarker } from 'assets/images/icons/wifi-marker.svg';
import { ReactComponent as AccountEditOutline } from 'assets/images/icons/account-edit-outline.svg';
import { ReactComponent as QuickTrainingIcon } from 'assets/images/icons/lightning-bolt-outline.svg';
import { ReactComponent as SaveOffIcon } from 'assets/images/icons/content-save-off-outline.svg';
import { ReactComponent as HospitalBuildingIcon } from 'assets/images/icons/hospital-building.svg';
import { ReactComponent as StethescopeIcon } from 'assets/images/icons/stethoscope.svg';
import { ReactComponent as SyringeIcon } from 'assets/images/icons/needle.svg';
import { ReactComponent as ClockAlertIcon } from 'assets/images/icons/clock-alert-outline.svg';
import { ReactComponent as SyringeOffIcon } from 'assets/images/icons/needle-off.svg';
import { ReactComponent as HomeRemoveOutlineIcon } from 'assets/images/icons/home-remove-outline.svg';
import { ReactComponent as DominoMaskIcon } from 'assets/images/icons/domino-mask.svg';




export default function Icon(props) {
  const {type, ...newProps} = props;
  newProps.className = `${newProps.className || ''} ${type} pt-icon`;

  switch (type) {

    // main menu icons

    case 'home':
      return <HomeOutlinedIcon {...newProps} />

    case 'search':
      return <SearchIcon {...newProps} />

    case 'training':
      return <SvgIcon {...newProps}><TrainingIconSVG /></SvgIcon>

    case 'event':
      return <EventOutlinedIcon {...newProps} />

    case 'exercise':
      return <SvgIcon {...newProps}><ExerciseIconSVG /></SvgIcon>

    case 'group':
      return <SvgIcon {...newProps} style={{transform: 'scaleX(0.9)'}}><AccountGroupOutlineIconSVG /></SvgIcon>

    case 'class':
      return <SchoolOutlinedIcon {...newProps} />

    case 'vet-visit':
      return <SvgIcon {...newProps} ><HospitalBuildingIcon /></SvgIcon>

    case 'deployment':
      return <SvgIcon {...newProps}><DeployIconSVG /></SvgIcon>

    case 'report':
      return <SvgIcon {...newProps}><ScriptTextOutlineIconSVG /></SvgIcon>

    case 'support':
      return <ContactSupportOutlinedIcon {...newProps} />

    case 'contact':
      return <ChatOutlinedIcon {...newProps} />

    case 'tutorial':
      return <VideoLibraryOutlinedIcon {...newProps} />

    case 'user-guide':
      return <DescriptionOutlinedIcon {...newProps} />

    case 'settings':
      return <SettingsOutlinedIcon {...newProps} />

    case 'profile':
      return <AccountCircleOutlinedIcon {...newProps} />

    case 'dog-profile':
      return <SvgIcon {...newProps}><DogsIconSVG /></SvgIcon>

    case 'custom':
      return <TuneIcon {...newProps} />

    case 'billing':
      return <MonetizationOnOutlinedIcon {...newProps} />

    case 'records':
      return <SvgIcon {...newProps}><RecordsIconSVG /></SvgIcon>

    case 'email':
      return <MailOutlineIcon {...newProps} />


    // app-bar & user-management

    case 'role':
      return <WorkOutlineIcon {...newProps} />

    case 'handler':
      return <PersonOutlineRoundedIcon {...newProps} />

    case 'supervisor':
      return <SupervisorAccountOutlinedIcon {...newProps} />

    case 'trainer':
      return <PeopleOutlineOutlinedIcon {...newProps} />

    case 'logout':
      return <ExitToAppIcon {...newProps} />

    case 'notification':
      return <NotificationsNoneRoundedIcon {...newProps} />

    case 'refresh':
      return <RefreshIcon {...newProps} />

    case 'dark-mode-toggle':
      return <InvertColorsIcon {...newProps} />


    // user profile

    case 'notifications-edit':
      return <SvgIcon {...newProps}><NotificationsEditIcon /></SvgIcon>

    case 'department':
      return <SvgIcon {...newProps}><PoliceStationSVG /></SvgIcon>

    case 'password':
      return <LockOutlined {...newProps} />
    
    case 'passcode':
      return <DialpadIcon {...newProps} />



    // dog-specific

    case 'attributes':
      return <SvgIcon {...newProps}><DogTypesIconSVG /></SvgIcon>

    case 'stats':
      return <EqualizerIcon {...newProps} />

    case 'default-dog':
      return <VerifiedUserIcon {...newProps} />



    // completion status

    case 'upcoming':
      return <QueryBuilderIcon {...newProps} />

    case 'incomplete':
      return <SvgIcon {...newProps}><CircleHalfFull /></SvgIcon>

    case 'complete':
      return <CheckCircleIcon {...newProps} />

    case 'complete-outlined':
      return <CheckCircleOutlineRoundedIcon {...newProps} />

    case 'late-completion': 
      return <SvgIcon {...newProps}><ClipboardClockOutline /></SvgIcon>

    case 'outdated': 
      return <SvgIcon {...newProps} style={{transform: 'scale(1.1) translateX(0.5px)'}}><ReloadAlert /></SvgIcon>


    
    // applicability

    case 'applicable':
      return <RadioButtonCheckedIcon {...newProps} />

    case 'not-applicable':
      return <RemoveCircleIcon {...newProps} />



    // record properties and sections

    case 'summary':
      return <SvgIcon {...newProps}><NewspaperVariantOutlineIconSVG /></SvgIcon>

    case 'date':
      return <QueryBuilderIcon {...newProps} />

    case 'location':
      return <LocationOnOutlinedIcon {...newProps} />

    case 'location-add':
      return <SvgIcon {...newProps}><LocationAddOutline /></SvgIcon>

    case 'map': 
      return <MapOutlinedIcon {...newProps} />

    case 'description':
      return <SvgIcon {...newProps}><PlaylistEditIconSVG /></SvgIcon>

    case 'tag':
      return <LocalOfferOutlinedIcon {...newProps} />

    case 'documents':
      return <LibraryBooksIcon {...newProps} />

    case 'comment':
      return <SvgIcon {...newProps}><CommentQuoteOutlineIconSVG /></SvgIcon>

    case 'weather':
      return <CloudOutlinedIcon {...newProps} />

    case 'applicable-dogs':
      return <SvgIcon {...newProps}><AccountQuestionmarkOutlineIconSVG /></SvgIcon>

    case 'trainer-comments': 
      return <SvgIcon {...newProps}><CommentMultipleOutline /></SvgIcon>

    case 'camera-marker':
      return <SvgIcon {...newProps}><CameraMarkerOutline /></SvgIcon>



    // event attendance

    case 'attendance': 
      return <SvgIcon {...newProps}><EventQuestionIcon /></SvgIcon>

    case 'attending':
      return <EventAvailableOutlinedIcon {...newProps} />

    case 'not-attending':
      return <EventBusyOutlinedIcon {...newProps} />

    case 'undecided': 
      return <SvgIcon {...newProps}><EventQuestionIcon /></SvgIcon>



    // detection

    case 'detection':
      return <SvgIcon {...newProps}><BriefcaseSearchOdorOutlineIconSVG /></SvgIcon>

    case 'environment':
      return <PhotoLibraryOutlinedIcon {...newProps} />

    case 'odor-environment':
      return <SvgIcon {...newProps}><ImageSearchOutlineIconSVG /></SvgIcon>

    case 'odor':
      return <SvgIcon {...newProps}><BottleTonicSprayIconSVG /></SvgIcon>

    case 'vehicle':
      return <DirectionsCarIcon {...newProps} />



    // patrol

    case 'patrol-agility':
      return <SvgIcon {...newProps}><LadderIconSVG /></SvgIcon>

    case 'patrol-apprehension':
      return <SvgIcon {...newProps}><RunFastIconSVG /></SvgIcon>

    case 'patrol-building-search':
      return <SvgIcon {...newProps}><HomeCityOutlineIconSVG /></SvgIcon>

    case 'patrol-evidence-search':
      return <FingerprintIcon {...newProps} />

    case 'patrol-human-search':
      return <SvgIcon {...newProps}><AccountSearchOutlineIconSVG /></SvgIcon>

    case 'patrol-obedience':
      return <SvgIcon {...newProps}><WhistleOutlineModIconSVG /></SvgIcon>

    case 'patrol-tracking':
      return <SvgIcon {...newProps}><MapMarkerPathIconSVG /></SvgIcon>

    case 'patrol-other':
      return <SvgIcon {...newProps}><ShapeOutlineIconSVG /></SvgIcon>

    case 'patrol-non-search':
      return <SvgIcon {...newProps}><RunFastIconSVG /></SvgIcon>

    case 'patrol-arrests-bites':
      return <PeopleOutlineOutlinedIcon {...newProps} />

    case 'patrol-scenario':
      return <SvgIcon {...newProps}><ClipboardMultipleOutlineSVG /></SvgIcon>



    // quick training

    case 'quick-training':
      return <SvgIcon {...newProps}><QuickTrainingIcon /></SvgIcon>


      
    // review

    case 'not-reviewed':
      return <SvgIcon {...newProps}><ShieldAccountOutlineSVG /></SvgIcon>

    case 'accepted':
      return <SvgIcon {...newProps}><ShieldAccountSVG /></SvgIcon>

    case 'rejected':
      return <SvgIcon {...newProps}><ShieldAlertSVG /></SvgIcon>
    
    case 'reviewed':
      return <SvgIcon {...newProps}><ShieldCheckIcon /></SvgIcon>


    // audit history
    
    case 'history':
      return <HistoryOutlinedIcon {...newProps} />

    case 'open-link':
      return <LaunchOutlinedIcon {...newProps} />

    
    // reporting

    case 'report-all':
      return <SvgIcon {...newProps}><TextBoxOutline /></SvgIcon>
    
    case 'report-searched':
      return <SvgIcon {...newProps}><TextBoxSearchOutline /></SvgIcon>

    case 'report-selected':
      return <SvgIcon {...newProps}><TextBoxCheckOutline /></SvgIcon>

    case 'report-warning':
      return <AssignmentLateIcon {...newProps} />


    // billing

    case 'subscription': 
      return <SvgIcon {...newProps}><CardAccountDetails /></SvgIcon>

    case 'cancel-subscription':
      return <SvgIcon {...newProps}><CardRemove /></SvgIcon>

    case 'billing-portal':
      return <SvgIcon {...newProps}><CardEdit /></SvgIcon>

    case 'billing-edit':
      return <SvgIcon {...newProps}><CalendarRefresh /></SvgIcon>


    // manage

    case 'manage-supervisors':
      return <SvgIcon {...newProps}><AccountTieHatOutlne /></SvgIcon>

    case 'manage-handlers':
      return <SvgIcon {...newProps}><HumanQueue /></SvgIcon>

    case 'manage-pending':
      return <MailOutlineIcon {...newProps} />

    case 'manage-managers': 
      return <SvgIcon {...newProps}><AccountTieHatOutlne /></SvgIcon>
      

    // groups

    case 'group-manager':
      return <SvgIcon {...newProps}><AccountTieHatOutlne /></SvgIcon>

    case 'group-training':
      return <SvgIcon {...newProps}><Ungroup /></SvgIcon>

    case 'group-handlers':
      return <SvgIcon {...newProps}><HumanQueue /></SvgIcon>

    case 'group-members':
      return <SvgIcon {...newProps}><GroupMembers /></SvgIcon>

    case 'group-add-members':
      return <SvgIcon {...newProps}><AccountMultiplePlusOutlineIconSVG /></SvgIcon>

    case 'group-leave':
      return <SvgIcon {...newProps}><ExitRun /></SvgIcon>

    case 'group-accept':
      return <SvgIcon {...newProps}><AccountCheckOutline /></SvgIcon>

    case 'group-request-send':
      return <SvgIcon {...newProps}><EmailFastOutline /></SvgIcon>

    case 'group-request-receive':
      return <EmailOutlinedIcon {...newProps} />


    // tracking    

    case 'layers':
      return <LayersIcon {...newProps} />

    case 'location-accuracy':
      return <SvgIcon {...newProps}><WifiMarker /></SvgIcon>

    case 'my-location':
      return <NearMeIcon {...newProps} />

    case 'location-on':
      return <SvgIcon {...newProps}><MapMarkerRadiusOutline /></SvgIcon>

    case 'location-off':
      return <LocationOffOutlinedIcon {...newProps} />

    case 'marker':
      return <SvgIcon {...newProps}><MapMarkerStarOutline /></SvgIcon>

    case 'tracking-start':
      return <PlayArrowOutlinedIcon {...newProps} />

    case 'tracking-stop':
      return <StopOutlinedIcon {...newProps} />

    case 'tracking-paused':
      return <SvgIcon {...newProps}><SaveOffIcon /></SvgIcon>

    case 'share':
      return <IosShareOutlinedIcon {...newProps} />

    case 'globe': 
      return <PublicOutlinedIcon {...newProps} />

    case 'track-deployment':
      return <SvgIcon {...newProps}><DeployIconSVG /></SvgIcon>;

    case 'track-lead':
      return <DirectionsRunIcon {...newProps} />

    case 'track-follow':
      return <SvgIcon {...newProps}><DogService /></SvgIcon>;

    case 'timer':
      return <TimerOutlinedIcon {...newProps} />;

    case 'distance':
      return <PolylineOutlinedIcon {...newProps} />;

    case 'upload': 
      return <CloudUploadOutlinedIcon {...newProps} />;

    case 'save':
      return <SaveIcon {...newProps} />;

    case 'pin-creator':
      return <SvgIcon {...newProps}><AccountEditOutline /></SvgIcon>;

    case 'tracking-admin':
      return <PolylineOutlinedIcon {...newProps} />;


    // vet visits

    case 'vet-care-type':
      return <SvgIcon {...newProps}><StethescopeIcon /></SvgIcon>;

    case 'vaccination':
      return <SvgIcon {...newProps}><SyringeIcon /></SvgIcon>;

    case 'vaccination-missing':
      return <SvgIcon {...newProps}><SyringeOffIcon /></SvgIcon>;

    case 'vaccination-due-status':
      return <SvgIcon {...newProps}><ClipboardClockOutline /></SvgIcon>

    case 'booked':
      return <EventAvailableOutlinedIcon {...newProps} />

    case 'not-booked':
      return <EventBusyOutlinedIcon {...newProps} />



    // general purpose symbols

    case 'menu':
      return <MoreHorizIcon {...newProps} />

    case 'menu-burger':
      return <MenuIcon {...newProps} />

    case 'add':
      return <AddIcon {...newProps} />

    case 'add-box':
      return <AddBoxIcon {...newProps} />

    case 'add-circle':
      return <AddCircleOutlineIcon {...newProps} />

    case 'view':
      return <SvgIcon {...newProps}><FileEyeOutlineIconSVG /></SvgIcon>

    case 'edit':
      return <EditOutlinedIcon {...newProps} />

    case 'delete':
      return <DeleteOutlinedIcon {...newProps} />

    case 'copy':
      return <FileCopyOutlinedIcon {...newProps} />

    case 'close':
      return <CloseIcon {...newProps} />

    case 'close-box':
      return <SvgIcon {...newProps} ><CloseBoxIconSVG /></SvgIcon>

    case 'mobile-close-drawer':
      return <SvgIcon {...newProps}><ChevronDownCircleOutlineIconSVG /></SvgIcon>

    case 'checkmark':
      return <DoneIcon {...newProps} />

    case 'checkmark-outline':
      return <DoneOutlineIcon {...newProps} />

    case 'check-all':
      return <DoneAllIcon {...newProps} />
  
    case 'filled-star':
      return <StarIcon {...newProps}/>

    case 'outlined-star':
      return <StarBorderIcon {...newProps}/>

    case 'filled-circle':
      return <SvgIcon {...newProps} style={{transform: 'scale(0.9)'}}><CheckboxBlankCircleSVG /></SvgIcon>

    case 'filled-plus':
      return <SvgIcon {...newProps}><PlusSVG /></SvgIcon>

    case 'outlined-circle':
      return <SvgIcon {...newProps} style={{transform: 'scale(0.9)'}}><CheckboxBlankCircleOutlineSVG /></SvgIcon>
    
    case 'filled-square':
      return <SvgIcon {...newProps} style={{transform: 'scale(0.9)'}}><SquareIconSVG /></SvgIcon>

    case 'outlined-square':
      return <SvgIcon {...newProps} style={{transform: 'scale(0.9)'}}><SquareOutlinedIconSVG /></SvgIcon>
            
    case 'filled-star-multiple':
      return <SvgIcon {...newProps}><FilledStarMultipleSVG /></SvgIcon>
    
    case 'outlined-star-multiple':
      return <SvgIcon {...newProps}><OutlinedStarMultipleSVG /></SvgIcon>
    
    case 'filled-circle-multiple':
      return <SvgIcon {...newProps}><FilledCircleMultipleSVG /></SvgIcon>
    
    case 'outlined-circle-multiple':
      return <SvgIcon {...newProps}><OutlinedCircleMultipleSVG /></SvgIcon>

    case 'filled-square-multiple':
      return <SvgIcon {...newProps}><FilledSquareMultipleSVG /></SvgIcon>

    case 'outlined-square-multiple':
      return <SvgIcon {...newProps}><OutlinedSquareMultipleSVG /></SvgIcon>

    case 'filled-plus-multiple':
      return <SvgIcon {...newProps}><PlusMultipleSVG /></SvgIcon>

    case 'lightning':
      return <LightningIcon {...newProps} />

    case 'expander':
      return <ExpandMoreIcon {...newProps} />

    case 'collapse':
      return <ExpandLessIcon {...newProps} />

    case 'arrow-down':
      return <ArrowDropDownIcon {...newProps} />

    case 'arrow-up':
      return <ArrowDropUpIcon {...newProps} />

    case 'arrow-right':
      return <ArrowRightIcon {...newProps} />

    case 'arrow-left':
      return <ArrowLeftIcon {...newProps} />

    case 'arrow-down-bold':
      return <SvgIcon {...newProps}><ArrowDownBoldIcon /></SvgIcon>

    case 'arrow-up-bold':
      return <SvgIcon {...newProps}><ArrowUpBoldIcon /></SvgIcon>

    case 'chevron-right':
      return <ChevronRightIcon {...newProps} />

    case 'nav-forward':
      return <ArrowForwardIosIcon {...newProps} />

    case 'nav-back':
      return <ArrowBackIosIcon {...newProps} style={{transform: 'translateX(20%)'}} />

    case 'photo':
      return <PhotoCameraOutlinedIcon {...newProps} />

    case 'add-photo':
      return <AddAPhotoOutlinedIcon {...newProps} />

    case 'open-in-tab':
      return <OpenInNewIcon {...newProps} />

    case 'warning':
      return <WarningOutlinedIcon {...newProps} />

    case 'warning-circle':
      return <ErrorOutlineOutlinedIcon {...newProps} />

    case 'info':
      return <InfoOutlinedIcon {...newProps} />

    case 'exclamation':
      return <ErrorOutlineIcon {...newProps} />

    case 'help':
      return <HelpOutlineIcon {...newProps} />

    case 'drag':
      return <DragIndicatorIcon {...newProps} />

    case 'transfer':
      return <SvgIcon {...newProps}><TransferIconSVG /></SvgIcon>

    case 'flag':
      return <SvgIcon {...newProps}><FlagVariantOutlineIconSVG /></SvgIcon>

    case 'bookmark':
      return <BookmarkBorderIcon {...newProps} />

    case 'fullscreen':
      return <FullscreenIcon {...newProps} />

    case 'fullscreen-exit':
      return <FullscreenExitIcon {...newProps} />

    case 'feedback':
      return <FeedbackOutlinedIcon {...newProps} />

    case 'tour':
      return <SvgIcon {...newProps}><BusIconSVG /></SvgIcon>

    case 'new':
      return <FiberNewIcon {...newProps} />

    case 'download':
      return <CloudDownloadOutlinedIcon {...newProps} />

    case 'visibility-on':
      return <VisibilityIcon {...newProps} />

    case 'visibility-off':
      return <VisibilityOffIcon {...newProps} />

    case 'lock':
      return <LockOutlined {...newProps} />

    case 'sync':
      return <SyncIcon {...newProps} />

    case 'sync-problem':
      return <SyncProblemIcon {...newProps} />

    case 'filter-list':
      return <FilterListIcon {...newProps} />

    case 'filter-plus':
      return <SvgIcon {...newProps}><FilterPlusIconSVG /></SvgIcon>

    case 'filter-remove':
      return <SvgIcon {...newProps}><FilterRemoveIconSVG /></SvgIcon>

    case 'todo':
      return <SvgIcon {...newProps}><ClipboardCheckIconSVG /></SvgIcon>

    case 'shortcut':
      return <SvgIcon {...newProps}><ShortcutIconSVG /></SvgIcon>

    case 'tip':
      return <SvgIcon {...newProps}><LightbulbOnOutlineSVG /></SvgIcon>
      
    case 'label':
      return <LabelOutlinedIcon {...newProps} />

    case 'zoom-in': 
      return <AddIcon {...newProps} />

    case 'zoom-out':
      return <RemoveIcon {...newProps} />

    case 'clock':
      return <AccessTimeOutlinedIcon {...newProps} />;

    case 'clock-alert':
      return <SvgIcon {...newProps}><ClockAlertIcon /></SvgIcon>
      
    case 'home-remove-outline':
      return <SvgIcon {...newProps}><HomeRemoveOutlineIcon /></SvgIcon>

    case 'user-admin':
      return <AccountBoxIcon {...newProps} />

    case 'impersonate':
      return <SvgIcon {...newProps}><DominoMaskIcon /></SvgIcon>

    default:
      return null;
  }
}